import { Component, Input, OnInit, ChangeDetectorRef, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Http } from '@angular/http';
import { setTimeout } from 'timers';
import 'rxjs/add/operator/map';
import { SearchCriteria } from '../../utils/searchCriteria';
import { ConnectedUserComponent } from '../connectedUserComponent';
import { StatiqueService } from '../../services/statique.service';

@Component({
	selector: 'app-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent extends ConnectedUserComponent implements OnInit {

	@Input() sMultiple: string;
	@Input() placeholder: string;
	@Input() srcTypeahead: string;
	@Input() srcListItems: string;
	@Input() name: string;
	@Input() defaultValue: any;
	@Input() fetchAttribute: string;
	@Input() fetchValue: any;
	@Input() options: any;
	@Input() listItems: any;
	@Input() groupByAttr?: string;
	@Input() fetchGroupByAttribute?: string;
	@Output() ebCompagnieNum: EventEmitter<number> = new EventEmitter<number>();
	@Input() etabCompagnieNum: number;

	public multiple: boolean;
	public selectedItem: any;
	public listTermsTypeahead: any;

	typeaheadEvent: EventEmitter<String> = new EventEmitter<string>();

	constructor(
		protected cd: ChangeDetectorRef,
		private statiqueService: StatiqueService
	) {
		super();
	}

	ngOnInit() {
		this.multiple = this.sMultiple == "true";

		if (this.defaultValue) {
			
			if (this.multiple)
				this.selectedItem = JSON.parse(this.defaultValue);
			else{
				if(Number(this.defaultValue)) this.selectedItem = Number(this.defaultValue);
				else this.selectedItem = this.defaultValue.length > 0 ? JSON.parse(this.defaultValue)[0] : "";
			}				
		}

		if (!this.defaultValue && this.srcTypeahead)
			this.srcListItems = null;

		this.getListItems();

		this.setTypeahead();


	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.name == "chargeurEbEtablissementNum" && (changes.etabCompagnieNum.currentValue != null && (changes.etabCompagnieNum.currentValue != changes.etabCompagnieNum.previousValue) ) ) {
			this.etabCompagnieNum = changes.etabCompagnieNum.currentValue;
			this.getListItems();			
		}		
	}

	selectChanged($event) {		
		if (this.name == "ebCompagnieNum" && $event) {
			this.ebCompagnieNum.emit($event.ebCompagnieNum);
		}
		else {
			this.ebCompagnieNum.emit(null);
		}

	}

	getListItems() {
		
		if (this.srcListItems) {
			this.listItems = [];
			this.getListFromSource(this.srcListItems).subscribe(function (res) {
				this.listItems = res;								
			}.bind(this));

			return true;
		}
		else if (this.listItems)
			return true;

		return false;
	}

	setTypeahead() {
		if (!this.srcTypeahead)
			return false;

		this.typeaheadEvent
			// .distinctUntilChanged()
			// .debounceTime(200)
			.switchMap(term => this.getTermsFromSource(term, this.srcTypeahead))
			.subscribe(data => {
				this.cd.markForCheck();
				this.listItems = data;
			}, (err) => {
				this.listItems = [];
			});

		return true;
	}

	getListFromSource(apiUrl) {
		if (this.etabCompagnieNum)
			return this.statiqueService.getListFromSource(apiUrl, this.etabCompagnieNum);
		//if (this.name != "chargeurEbEtablissementNum")
			return this.statiqueService.getListFromSource(apiUrl);
	}
	getTermsFromSource(term, apiUrl) {
		if (term == "" || !term)
			term = "*"
		if (this.etabCompagnieNum)
			return this.statiqueService.getTermsFromSource(term, apiUrl, this.etabCompagnieNum);
		//if (this.name != "chargeurEbEtablissementNum")
			return this.statiqueService.getTermsFromSource(term, apiUrl);
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/autocomplete/autocomplete.component.ts